/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { useState, useEffect, useRef } from 'react'; // eslint-disable-next-line
import { copiriAxiosPost, copiriPortalRequest } from '../../../api/api'; // eslint-disable-next-line
import config from '../../../config/config'; // eslint-disable-next-line
import { toast } from 'react-toastify';
// eslint-disable-next-line
import FormGroupInput from '../../../common/FormGroupInput';
import { Row, Col, Button, Form } from 'react-bootstrap';
// eslint-disable-next-line
import CopiriLoader from '../../../common/CopiriLoader';
import image_loader from '../../../../assets/img/loader/small_loader.gif'; // eslint-disable-next-line
const RiteField = props => {
	// eslint-disable-next-line
	const { lodgeData, id, closeModal, updateLodgeModal, pageLanguageContent } = props; // eslint-disable-next-line
	const [checkDataChange, setCheckDataChange] = useState(false);
	const [showLoader, setShowLoader] = useState(false);
	const [showHideLoader, setShowHideLoader] = useState(false);
	const [showHideTextBox, setShowHideTextBox] = useState(false);
	const [riteData, setRiteData] = useState([]);
	const [inputField, setInputField] = useState({
		rite: ''
	});

	const [validation, setValidation] = useState({
		error_rite: ''
	});
	useEffect(() => {
		getDorpDownData();
		if (props.id) {
			const { rite } = lodgeData;
			if (rite !== 'Rite not provided.') setInputField({ ...inputField, rite });
		}
		// eslint-disable-next-line
	}, [props.id]);

	const inputsHandler = e => {
		setCheckDataChange(true);
		if (e.target.value === 'other_rite') {
			setShowHideTextBox(true);
			setInputField({ ...inputField, [e.target.name]: '' });
		} else {
			setInputField({ ...inputField, [e.target.name]: e.target.value });
		}
	};

	function getDorpDownData() {
		setShowHideLoader(true);
		setRiteData([]);
		copiriPortalRequest('/canon/additionalinfo/rite', config.app_version, 'get')
			.then(response => {
				setShowHideLoader(false);
				if (response.data.values.length > 0) {
					setRiteData(response.data.values);
				}
			})
			.catch(error => {
				setShowHideLoader(false);
			});
	}

	function updateData() {
		let errors = { ...validation };
		var errorCount = 0;

		if (!inputField.rite.trim()) {
			errors.error_rite = pageLanguageContent['CLD071'];
			errorCount++;
		} else {
			errors.error_rite = '';
		}
		var sendData = {};
		sendData['value'] = inputField['rite'];
		sendData['type'] = 'Rite';

		setValidation(errors);
		if (errorCount <= 0) {
			setShowLoader(true);
			copiriPortalRequest('/organizations/' + id + '/additional-info', config.app_version, 'patch', sendData)
				.then(response => {
					setShowLoader(false);
					if (response.data.status && response.data.status === 'SUCCESS') {
						toast.success(pageLanguageContent['CLD119']);
						closeModal();
						updateLodgeModal('rite', inputField['rite']);
					}
				})
				.catch(error => {
					toast.error(error.response.data.result);
					setShowLoader(false);
				});
		}
	}

	return (
		<>
			{showHideLoader ? (
				<CopiriLoader />
			) : (
				<Row className='mt-2'>
					<Col lg={12}>
						{showHideTextBox ? (
							<FormGroupInput
								id='rite'
								label={pageLanguageContent['CLD030'] ? pageLanguageContent['CLD030'] : ''}
								placeholder={pageLanguageContent['CLD030'] ? pageLanguageContent['CLD030'] : ''}
								type='text'
								name='rite'
								onChange={inputsHandler}
								value={inputField.rite}
							/>
						) : (
							<Form.Group className='form-group'>
								<Form.Label for='language'>
									{pageLanguageContent['CLD030'] ? pageLanguageContent['CLD030'] : ''}
								</Form.Label>
								<select
									className='form-control'
									id='rite'
									type='text'
									name='rite'
									onChange={inputsHandler}
									value={inputField.rite}
								>
									<option value=''>{pageLanguageContent['CLD187'] ? pageLanguageContent['CLD187'] : ''}</option>
									{riteData.length > 0 &&
										riteData.map((item, i) => (
											<option value={item} key={i}>
												{item}
											</option>
										))}
									<option value='other_rite'>
										{pageLanguageContent['CLD188'] ? pageLanguageContent['CLD188'] : ''}
									</option>
								</select>
							</Form.Group>
						)}

						{validation.error_rite && <p className='formValidationError'>{validation.error_rite}</p>}
					</Col>
					<Col lg={12}>
						<Button
							variant='primary'
							id={'confirmValidatebutton'}
							style={{ float: 'right', marginBottom: '15px' }}
							onClick={updateData}
						>
							{showLoader ? (
								<img src={image_loader} alt='loader' height='20' width='20' />
							) : pageLanguageContent['CLD124'] ? (
								pageLanguageContent['CLD124']
							) : (
								''
							)}
						</Button>
					</Col>
				</Row>
			)}
		</>
	);
};
export default RiteField;
